import type { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";

import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";
import { useQuestionnaireParitySession } from "@/modules/add-new-data/stores/questionnaire-parity-session";
import { RbimHouseholdQuestionsStep as DesktopHouseholdQuestionsStep } from "@/modules/add-new-data/components/rbim-household-questions-step-desktop";

type RbimHouseholdQuestionsStepProps = {
  errors: FieldErrors<AddNewDataFormValues>;
  family?: AddNewDataFormValues["household"]["family"];
  register: UseFormRegister<AddNewDataFormValues>;
  setValue: UseFormSetValue<AddNewDataFormValues>;
  values: AddNewDataFormValues["householdQuestions"];
};

export function RbimHouseholdQuestionsStep(props: RbimHouseholdQuestionsStepProps) {
  const parityFamily = useQuestionnaireParitySession((state) => state.family);
  const family = props.family || parityFamily;

  return (
    <DesktopHouseholdQuestionsStep
      errors={props.errors}
      family={family}
      register={props.register}
      setValue={props.setValue}
      values={props.values}
    />
  );
}
